export const CLOSE_SLIDER = 'CLOSE_SLIDER';
export const OPEN_SLIDER = 'OPEN_SLIDER';
export const TOGGLE_SLIDER = 'TOGGLE_SLIDER';
